import "./App.css";
import Router from "../router/Router";
import { ThemeProvider } from "@mui/material";
import { theme } from "../styles/Theme";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { asyncStoragePersister, queryClient } from "../utils/ReactQueryConfig";
import { I18nextProvider } from "react-i18next";
import i18n from "../locales/i18n.config";
import { useEffect } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Config from "../utils/EnvConfig";

function App() {
  useEffect(() => {
    document.title = Config.APP_TITLE ?? "ORVA";
  }, []);

  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{ persister: asyncStoragePersister }}
    >
      <ThemeProvider defaultMode="light" theme={theme}>
        <I18nextProvider i18n={i18n}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Router />
          </LocalizationProvider>
        </I18nextProvider>
      </ThemeProvider>
    </PersistQueryClientProvider>
  );
}

export default App;
